'use client';

import { c as _c } from "react/compiler-runtime";
import { type GetThesesRow, useActiveWallet, useAuth, useGetThesesInfinite } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import { ThesisFeed } from '@/components/social/debate/thesis-feed';
import type { ThesisItem } from '@/components/social/types';
import { useLiveListData } from '@/hooks/sdk/use-live-list-data';
import { isThesisAttributedToWallet } from '@/lib/wallet/multi-wallet-scope';

// ---------------------------------------------------------------------------
// Props
// ---------------------------------------------------------------------------

interface UserThesesSectionProps {
  userId: string;
  walletPubkeys: readonly string[];
  attributionWalletAddress?: string | null;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function UserThesesSection(t0) {
  const $ = _c(24);
  const {
    userId,
    walletPubkeys,
    attributionWalletAddress: t1
  } = t0;
  const attributionWalletAddress = t1 === undefined ? null : t1;
  const t = useTranslations("social");
  const {
    isAuthenticated
  } = useAuth();
  const {
    activeWallet
  } = useActiveWallet();
  const viewerUserId = activeWallet?.address ?? null;
  let t2;
  if ($[0] !== userId || $[1] !== walletPubkeys) {
    t2 = {
      authorId: userId,
      walletPubkeys,
      sort: "recent"
    };
    $[0] = userId;
    $[1] = walletPubkeys;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const thesesQuery = useGetThesesInfinite(t2);
  const {
    isPending,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage
  } = thesesQuery;
  const rows = useLiveListData(thesesQuery.queryKey, thesesQuery.rows);
  let t3;
  if ($[3] !== attributionWalletAddress || $[4] !== rows) {
    t3 = attributionWalletAddress === null ? rows : rows.filter(row => isThesisAttributedToWallet(row, attributionWalletAddress));
    $[3] = attributionWalletAddress;
    $[4] = rows;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const attributedRows = t3;
  const theses = attributedRows as unknown as ThesisItem[];
  const t4 = hasNextPage === true;
  let t5;
  if ($[6] !== fetchNextPage) {
    t5 = () => {
      fetchNextPage();
    };
    $[6] = fetchNextPage;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isFetchingNextPage || $[9] !== isPending || $[10] !== t4 || $[11] !== t5) {
    t6 = {
      isLoading: isPending,
      hasNextPage: t4,
      isFetchingNextPage,
      fetchNextPage: t5,
      pageCount: 0
    };
    $[8] = isFetchingNextPage;
    $[9] = isPending;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("theses_empty_title");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("theses_empty_user");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isAuthenticated || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== theses || $[22] !== viewerUserId) {
    t9 = <ThesisFeed theses={theses} pagination={t6} isAuthenticated={isAuthenticated} userId={viewerUserId} emptyTitle={t7} emptyDescription={t8} variant="portfolio" />;
    $[17] = isAuthenticated;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = theses;
    $[22] = viewerUserId;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}